<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
export default { 
    page: {
        title: "Staffing Pattern",
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "Staffing Pattern",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Staffing Pattern",
                    active: true,
                },
            ],
            tableBusy: false,
            employmentTypes: [],
            tableData: [],
            years: [],
            staffForTheYear: {},
        }
    },
    async created(){
        this.tableBusy = true;
        await this.getEmploymentTypes();
        await this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.tableBusy = false;
    },
    methods: {
        async getEmploymentTypes(){
            await this.$store
                .dispatch("employmenttype/GetAllEmploymentType")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    this.employmentTypes = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!","error");
                });
        },
        async changeData(cycle, campusId){
            this.tableData = [];
            this.years = [
                {
                    year: cycle - 2,
                    editMode: false,
                },
                {
                    year: cycle - 1,
                    editMode: false,
                },
                {
                    year: cycle,
                    editMode: false,
                },
            ];
            await this.$store
                .dispatch("staffingpattern/GetAllStaffingPattern", {campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    this.tableData = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!","error");
                });
        },
        editYear(row){
            this.years.map(item => item.editMode = false);
            row.editMode = true;
            var editable = {};
            this.employmentTypes.forEach(x => {
                editable[`fill${x.id}`] = {
                    id: this.getSingleData(row.year, x.id) ? this.getSingleData(row.year, x.id).id : 0,
                    employmentTypeId: x.id,
                    total: this.getSingleData(row.year, x.id) ? (this.getSingleData(row.year, x.id).total == 0 ? "" : this.getSingleData(row.year, x.id).total) : "",
                    filled: this.getSingleData(row.year, x.id) ? (this.getSingleData(row.year, x.id).filled == 0 ? "" : this.getSingleData(row.year, x.id).filled) : "",
                    remarks: "",
                }
            })
            this.staffForTheYear = editable;
        },
        watchIfHasData(row){
            return this.tableData.filter(y => y.cycle == row.year);
        },
        getSingleData(year, empTypeId){
            return this.tableData.find(x => x.cycle == year && x.employmentTypeId == empTypeId)
        },
        unfilledCalc(data){
            if(!data) return '-';
            let total = data.total ? parseFloat(data.total) : 0;
            let filled = data.filled ? parseFloat(data.filled) : 0;
            let diff = total - filled;
            return diff <= 0 ? '-' : diff;
        },
        async saveYearChanges(row){
            let createData = [];
            let updateData = [];
            for(var key in this.staffForTheYear){
                let dat = this.staffForTheYear[key];
                if(dat.id > 0){
                    updateData.push({
                        id: dat.id,
                        campusId: this.$store.state.data.selectedCampus.id,
                        cycle: row.year,
                        employmentTypeId: dat.employmentTypeId,
                        total: dat.total ? this.getExactAmt(dat.total) : 0,
                        filled: dat.filled ? this.getExactAmt(dat.filled) : 0,
                        remarks: "",
                    })
                }else{
                    createData.push({
                        id: 0,
                        employmentTypeId: dat.employmentTypeId,
                        total: dat.total ? this.getExactAmt(dat.total) : 0,
                        filled: dat.filled ? this.getExactAmt(dat.filled) : 0,
                        remarks: "",
                    })
                }
            }
            if(createData.length){
                await this.$store
                    .dispatch("staffingpattern/CreateStaffingPattern", {
                        campusId: this.$store.state.data.selectedCampus.id,
                        cycle: row.year,
                        data: createData,
                    })
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        res.data.map(item => {
                            this.tableData.push(item);
                        })
                        row.editMode = false;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            if(updateData.length){
                await this.$store
                    .dispatch("staffingpattern/UpdateStaffingPattern", updateData)
                    .then(async (res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        for await(let x of updateData) {
                            let index = this.tableData.findIndex(y => y.id == x.id);
                            this.tableData[index].total = x.total;
                            this.tableData[index].filled = x.filled;
                        }
                        row.editMode = false;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
        },
        getTotalData(year){
            let data = this.tableData.filter(x => x.cycle == year);
            let sumOfTotal = data.reduce((accum, item) => accum + parseFloat(item.total), 0)
            let sumOfFilled = data.reduce((accum, item) => accum + parseFloat(item.filled), 0)
            return {total: sumOfTotal, filled: sumOfFilled}
        },
        getTotalUnfilled(year){
            let data = this.tableData.filter(x => x.cycle == year);
            let unfilled = 0;
            data.map(item => {
                let diff = parseFloat(item.total) - parseFloat(item.filled);
                unfilled += diff > 0 ? diff : 0;
            })
            return unfilled;
        }
    }
}
</script>
<template>
    <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event.id)">
        <PageHeader :title="title" :items="items" />
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th rowspan="2" class="vertical-middle" width="25%">Employment Types</th>
                    <template v-for="y in years" >
                        <th colspan="3" class="text-center" :key="`Y-${y.year}`" width="25%">
                            <div class="d-flex justify-content-center align-items-center" style="gap:5px;">
                                <a href="javascript:void(0);" class="font-size-18 text-yellow hover-underline" @click="editYear(y)">
                                    {{y.year}}
                                </a>
                                <template v-if="y.editMode">
                                    <a href="javascript:void(0);" class="text-green font-size-18 px-1 border border-success rounded font-weight-bold" @click="saveYearChanges(y)"><i class="bx bx-check"></i></a>
                                    <a href="javascript:void(0);" class="text-danger font-size-18 px-1 border border-danger rounded font-weight-bold" @click="y.editMode = false"><i class="bx bx-x"></i></a>
                                </template>
                            </div>
                            <small class="d-block font-size-10" v-if="!y.editMode"><i>Click the year to update the data</i></small>
                        </th>
                    </template>
                </tr>
                <tr>
                    <template v-for="y in years">
                        <th class="text-center" :key="`TP1-${y.year}`">Total Positions</th>
                        <th class="text-center" :key="`F1-${y.year}`">Filled</th>
                        <th class="text-center" :key="`UN1-${y.year}`">Unfilled</th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <template v-for="x in employmentTypes">
                    <tr :key="`ET-${x.id}`">
                        <td class="font-size-15 text-white font-weight-bold">{{x.type}}</td>
                        <template v-for="y in years">
                            <template v-if="y.editMode">
                                <td :key="`TPI2-${x.id}-${y.year}`">
                                    <input v-model="staffForTheYear[`fill${x.id}`].total" class="form-control text-center" />
                                </td>
                                <td :key="`FI2-${x.id}-${y.year}`">
                                    <input v-model="staffForTheYear[`fill${x.id}`].filled" class="form-control text-center"/>
                                </td>
                                <td :key="`UN12-${x.id}-${y.year}`" class="vertical-middle text-center">
                                    {{ unfilledCalc(staffForTheYear[`fill${x.id}`]) }}
                                </td>
                            </template>
                            <template v-else>
                                <template v-if="watchIfHasData(y).length">
                                    <td :key="`TP2-${x.id}-${y.year}`" class="text-center">{{getSingleData(y.year, x.id) ? (getSingleData(y.year, x.id).total == 0 ? '-' : getSingleData(y.year, x.id).total) : '-'}}</td>
                                    <td :key="`F2-${x.id}-${y.year}`" class="text-center">{{getSingleData(y.year, x.id) ? (getSingleData(y.year, x.id).filled == 0 ? '-' : getSingleData(y.year, x.id).filled) : '-'}}</td>
                                    <td :key="`UN2-${x.id}-${y.year}`" class="text-center">{{unfilledCalc(getSingleData(y.year, x.id))}}</td>
                                </template>
                                <template v-else>
                                    <td class="text-center" :key="`ND1-${x.id}-${y.year}`">-</td>
                                    <td class="text-center" :key="`ND2-${x.id}-${y.year}`">-</td>
                                    <td class="text-center" :key="`ND3-${x.id}-${y.year}`">-</td>
                                </template>
                            </template>
                        </template>
                    </tr>
                </template>
                <tr>
                    <td class="font-size-15 text-yellow font-weight-bold">Total</td>
                    <template v-for="y in years">
                        <td :key="`TTP2-${y.year}`" class="text-center text-white">{{getTotalData(y.year).total ? formatNumber(getTotalData(y.year).total) : '-'}}</td>
                        <td :key="`TF2-${y.year}`" class="text-center text-white">{{getTotalData(y.year).filled ? formatNumber(getTotalData(y.year).filled) : '-'}}</td>
                        <td :key="`TUN2-${y.year}`" class="text-center text-white">{{getTotalUnfilled(y.year)}}</td>
                    </template>
                </tr>
            </tbody>
        </table>
    </Layout>
</template>